import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=e1bc3bdc&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=e1bc3bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bc3bdc",
  null
  
)

export default component.exports